import type { dealerCodeToAccountMap } from "@dealer-center/ddc-api-lambda-helper-css";

export function populateMappingConfig(
  accountId: string,
  dealerCodeNumber: string,
  dealerCodeType: string
): dealerCodeToAccountMap {
  return {
    accountId,
    dealerCode: dealerCodeNumber,
    dealerCodeType
  };
}

interface accountInterface {
  id: string;
  displayName?: string;
}

export interface dealerCodeMappingEditModalInterface {
  id: string;
  account: accountInterface;
  dealerCode: string;
  dealerCodeType: string;
}

export interface dealerCodeMappingDeleteModalInterface {
  id: string;
  account: accountInterface;
  dealerCodeType: string;
}
